import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';
import { authPassportAtom, isAuthAtom } from 'Recoil/auth.atom';
import { authLogout } from 'Services/auth.services';
import { CartAtom } from 'Recoil/order.atom';
import { Route, Redirect, Switch, useHistory, useLocation } from 'react-router-dom';
import { isArray, isNil, map, isEmpty } from 'lodash';
import { fetchCartList } from 'Services/order.services';
import useNavigation from 'Hooks/navigation.hook';
import useSession from 'Hooks/session.hook';

import { UserOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { Avatar as AntAvatar, Badge, Space } from 'antd';

import {
  ActionMenu,
  Avatar,
  Button,
  // Header,
  Notifications
} from '@life-line-lab/components-react';
import { Layout, Footer } from 'Components/shared';

import navigation from './navigation';

import '@life-line-lab/components-react/build/index.css';
import './styles/base.scss';
import NaviBar from './components/shared/layout/navigation-bar/navbar';

import { Header, HeaderProps } from 'Components/shared';

const Protected = ({ children }) => {
  // const isAuth = useRecoilValue<boolean>(isAuthAtom);
  const session = useSession();

  return !isEmpty(session)
    ? <Route children={children} />
    : <Redirect to={{ pathname: '/login' }} />;
};

 const HeaderBody = () => {
  const history = useHistory();
   const location = useLocation();

  const { t } = useTranslation();

  return(
      <NaviBar/>
  )}
interface ShellProps {
  routes: any;
}

const Shell: React.FC<ShellProps> = ({ routes }) => {
  const logo = '/assets/images/logo.png';
  const authPassport = useRecoilValue<any>(authPassportAtom);
  const roleTypes = authPassport?.roleTypes;

  const renderNavigations = useNavigation({ navigation, roles: roleTypes });
  const contentHeader = '';

  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false); // for use in <Header />
  const headerProps: Omit<HeaderProps, 'hasSidebar' | 'onTogglerClick'> = {
    logoSrc: logo,
    logoSize: 'middle',
    logoHref: '/',
  }

  return (
    <Switch>
      {isArray(routes.public) &&
        map(routes.public, (route, index) => {
          if (route.isActive) {
            return (
              <Route
                key={index}
                path={route.path}
                strict={route.strict}
                exact={route.exact}
              >
                <React.Fragment>
                  {!route.withLayout &&
                    <React.Fragment>
                      <Header
                        hasSidebar={false}
                        onTogglerClick={() => setIsSidebarOpen(!isSidebarOpen)}
                        {...headerProps }
                        isFixed={false}
                      >
                        <HeaderBody />
                      </Header>

                      <div>
                        {route.component}

                        <Footer />
                      </div>
                    </React.Fragment>
                  }

                  {route.withLayout &&
                    <Layout
                      headerProps={headerProps}
                      headerChildren={<HeaderBody />}
                      contentHeaderChildren={contentHeader}
                      hasSidebar={false}
                      navigation={renderNavigations}
                    >
                      <Space direction="vertical" size="large">
                        {route.component}

                        <Footer />
                      </Space>
                    </Layout>
                  }
                </React.Fragment>
              </Route>
            );
          }
        })
      }

      {isArray(routes.protected) &&
        map(routes.protected, (route, index) => {
          if (route.isActive) {
            return (
              <Route
                key={index}
                path={route.path}
                strict={route.strict}
                exact={route.exact}
              >
                <Protected>
                  {!route.withLayout &&
                    <React.Fragment>
                      <Header
                        logoSrc={logo}
                        logoSize="middle"
                        logoHref="/"
                        hasSidebar={false}
                        isFixed={false}
                      >
                        <HeaderBody />
                      </Header>

                      <div>
                        {route.component}

                        <Footer />
                      </div>
                    </React.Fragment>

                  }

                  {route.withLayout &&
                    <Layout
                      headerProps={{
                        logoSrc: logo,
                        logoSize: 'middle',
                        logoHref: '/',
                      }}
                      headerChildren={<HeaderBody />}
                      contentHeaderChildren={contentHeader}
                      hasSidebar={false}
                      navigation={renderNavigations}
                    >
                      <Space direction="vertical" size="large">
                        {route.component}

                        <Footer />
                      </Space>
                    </Layout>
                  }
                </Protected>
              </Route>
            );
          }
        })
      }
    </Switch>
  );
}

export default Shell;
